import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, TriangleAlert } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth, errorMessage } from "@/lib/auth";
import "@/auth.css";

export default function AuthVerify() {
  const [params] = useSearchParams();
  const { verifyLink } = useAuth();
  const nav = useNavigate();
  const [error, setError] = useState("");
  const done = useRef(false);

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setError("Lien incomplet. Redemandez un lien de connexion."); return; }
    // React 18 monte deux fois en développement : le lien est à usage unique,
    // on garantit donc un seul appel.
    if (done.current) return;
    done.current = true;
    verifyLink(token)
      .then(user => nav(user.onboarded ? "/dashboard" : "/onboarding", { replace: true }))
      .catch(err => setError(errorMessage(err, "Ce lien est invalide ou a déjà été utilisé.")));
  }, [params, verifyLink, nav]);

  return (
    <div className="auth-screen">
      <div className="auth-card">
        <Link to="/" aria-label="Perform, accueil"><Logo /></Link>
        {error ? (
          <>
            <div className="auth-sent-icon is-error"><TriangleAlert size={22} /></div>
            <h1>Lien inutilisable.</h1>
            <p className="auth-lead" data-testid="verify-error">{error}</p>
            <Link to="/auth" className="button button-dark" data-testid="verify-retry">Demander un nouveau lien</Link>
          </>
        ) : (
          <>
            <div className="auth-sent-icon"><Loader2 size={22} className="animate-spin" /></div>
            <h1>Connexion en cours…</h1>
            <p className="auth-lead">Nous ouvrons votre espace.</p>
          </>
        )}
      </div>
    </div>
  );
}
